import { sortBy } from 'lodash-es';

import { DOT_CMS_SUB_CONTENTLET_KEYS } from '../../configurations/contentlet.config';

import { CustomDotCmsContentlet } from './custom-dotcms-contentlet.model';

export class CustomDotCmsContentletHelper {
  static getSubContentlet(
    contentlet: CustomDotCmsContentlet,
    contentlets?: CustomDotCmsContentlet[]
  ): CustomDotCmsContentlet[] {
    const changingContentlet = structuredClone(contentlet);

    if (!contentlets) {
      contentlets = [];
    }
    DOT_CMS_SUB_CONTENTLET_KEYS.forEach(key => {
      //@ts-ignore
      const subContentlets = changingContentlet[key];
      if (Array.isArray(subContentlets)) {
        if (subContentlets.length > 0) {
          subContentlets.forEach((subContentlet, index) => {
            CustomDotCmsContentletHelper.getSubContentlet(subContentlet, contentlets);
            if (subContentlet.identifier) {
              //@ts-ignore
              changingContentlet[key][index] = {
                identifier: subContentlet.identifier,
                contentType: subContentlet.contentType,
                sortOrder: subContentlet.sortOrder,
              };
            }
          });
        }
      } else if (typeof subContentlets === 'object') {
        if (subContentlets.type === 'doc') {
          //@ts-ignore
          subContentlets.content.forEach((content, index) => {
            switch (content.type) {
              case 'dotContent': {
                CustomDotCmsContentletHelper.getSubContentlet(subContentlets.content[index].attrs.data, contentlets);
                subContentlets.content[index] = {
                  identifier: content?.attrs?.data?.identifier,
                  contentType: content?.attrs?.data?.contentType,
                  sortOrder: content?.attrs?.data?.sortOrder,
                };

                break;
              }
              case 'dotImage': {
                subContentlets.content[index].attrs.data = {
                  ...subContentlets.content[index]?.attrs?.data,
                  fileAsset:
                    subContentlets.content[index]?.attrs?.src ||
                    subContentlets.content[index]?.attrs?.data?.assetVersion ||
                    subContentlets.content[index]?.attrs?.data?.fileAsset,
                  textAlign: subContentlets.content[index]?.attrs?.textAlign,
                  alt: subContentlets.content[index]?.attrs?.alt,
                  title: subContentlets.content[index]?.attrs?.title,
                  href: subContentlets.content[index]?.attrs?.href,
                };
                CustomDotCmsContentletHelper.getSubContentlet(subContentlets.content[index].attrs.data, contentlets);
                subContentlets.content[index] = {
                  identifier: content?.attrs?.data?.identifier,
                  contentType: 'Image',
                  sortOrder: content?.attrs?.data?.sortOrder,
                };

                break;
              }
              case 'dotVideo': {
                subContentlets.content[index].attrs.data = {
                  ...subContentlets.content[index]?.attrs?.data,
                  fileAsset: subContentlets.content[index]?.attrs?.src,
                };
                CustomDotCmsContentletHelper.getSubContentlet(subContentlets.content[index].attrs.data, contentlets);
                subContentlets.content[index] = {
                  identifier: content?.attrs?.data?.identifier,
                  contentType: 'DefaultVideo',
                  sortOrder: content?.attrs?.data?.sortOrder,
                };
                break;
              }
              // No default
            }
          });
        } else {
          CustomDotCmsContentletHelper.getSubContentlet(subContentlets, contentlets);
          //@ts-ignore
          changingContentlet[key] = {
            identifier: subContentlets.identifier,
            contentType: subContentlets.contentType,
            sortOrder: subContentlets.sortOrder,
          };
        }
      }
    });
    contentlets.push(changingContentlet);
    return contentlets;
  }
  static getSortedSubContentlets(
    contentlet: CustomDotCmsContentlet,
    subContentletKeys?: string[],
    key?: keyof CustomDotCmsContentlet
  ): CustomDotCmsContentlet[] {
    let contents: CustomDotCmsContentlet[] = [];
    Object.entries(contentlet).forEach(([keys, values]) => {
      if (subContentletKeys.includes(keys)) {
        contents = [...contents, ...values];
      }
    });

    contents = [
      ...sortBy(
        contents.filter(e => e[key] !== undefined && e[key] !== 0),
        e => e[key]
      ),
      ...contents.filter(e => !e[key]),
    ];
    return contents;
  }
}
